export default __webpack_public_path__ + "static/media/yajirusi_right.fb6b150d.png";